import React from "react";

const Warranties = () => {
  return (
    <div className="flex flex-col items-start sm:px-16 p-6">
      <h1 className="text-[1.9rem] font-bold tracking-wide ">
        K.
        <span className="text-[#01A7D1] "> DISCLAIMER OF WARRANTIES</span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <span className="text-lg font-medium">
          YOU AGREE THAT YOUR USE OF THE PLATFORM SHALL BE AT YOUR OWN RISK. TO
          THE FULLEST EXTENT PERMITTED BY LAW, YOSTEL AND ITS OFFICERS,
          MANAGERS, MEMBERS, DIRECTORS, EMPLOYEES, SUCCESSORS, ASSIGNS,
          SUBSIDIARIES, AFFILIATES, SUPPLIERS, AND AGENTS DISCLAIM ALL
          WARRANTIES, EXPRESS, IMPLIED,STATUTORY OR OTHERWISE, AND MAKE NO
          WARRANTIES, REPRESENTATIONS, OR GUARANTEES IN CONNECTION WITH THIS
          PLATFORM, THE SERVICES OFFERED ON OR THROUGH THIS PLATFORM, ANY DATA,
          MATERIALS, SUBMITTED CONTENT, RELATING TO THE QUALITY, SUITABILITY,
          TRUTH, ACCURACY OR COMPLETENESS OF ANY INFORMATION OR MATERIAL
          CONTAINED OR PRESENTED ON THIS PLATFORM, INCLUDING WITHOUT LIMITATION
          THE MATERIALS, DATA AND SUBMITTED CONTENT OF OTHER USERS OF THIS SITE
          OR OTHER THIRD PARTIES. UNLESS OTHERWISE EXPLICITLY STATED, TO THE
          MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THIS PLATFORM, THE
          SERVICES OFFERED ON OR THROUGH THIS PLATFORM, DATA, MATERIALS,
          SUBMITTED CONTENT, AND ANY INFORMATION OR MATERIAL CONTAINED OR
          PRESENTED ON THIS PLATFORM IS PROVIDED TO YOU ON AN “AS IS,” “AS
          AVAILABLE” AND “WHERE IS” BASIS WITH NO WARRANTY OF IMPLIED WARRANTY
          OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR
          NON-INFRINGEMENT OF THIRD-PARTY RIGHTS. Yostel DOES NOT PROVIDE ANY
          WARRANTIES AGAINST ERRORS, MISTAKES, OR INACCURACIES OF DATA, CONTENT,
          INFORMATION, MATERIALS, SUBSTANCE OF THE PLATFORM OR SUBMITTED
          CONTENT, ANY UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS
          AND/OR ANY AND ALL PERSONAL INFORMATION AND/OR FINANCIAL INFORMATION
          STORED THEREIN, ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE WHICH
          MAY BE TRANSMITTED TO OR THROUGH THE PLATFORM BY ANY THIRD PARTY, ANY
          INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM THE PLATFORM, ANY
          DEFAMATORY, OFFENSIVE, OR ILLEGAL CONDUCT OF ANY THIRD PARTY OR
          SERVICE USER OR SERVICE PROVIDER, OR ANY LOSS OR DAMAGE OF ANY KIND
          INCURRED AS A RESULT OF THE USE OF ANY DATA, CONTENT, INFORMATION,
          MATERIALS, SUBSTANCE OF THE PLATFORM OR SUBMITTED CONTENT POSTED,
          EMAILED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE PLATFORM.
          Yostel DOES NOT ENDORSE, WARRANT, GUARANTEE, OR ASSUME RESPONSIBILITY
          FOR ANY PRODUCT OR SERVICE ADVERTISED OR OFFERED BY A THIRD PARTY
          THROUGH THE PLATFORM OR ANY HYPERLINKED SITE OR FEATURED IN ANY BANNER
          OR OTHER ADVERTISEMENT.
        </span>
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <span className="text-lg font-medium">
          CERTAIN SERVICES ON THE PLATFORM OR ON THE PREMISES MAY BE PROVIDED
          THROUGH A THIRD PARTY VENDOR, IT IS AGREED AND CLARIFIED THAT UNDER NO
          CIRCUMSTANCES SHALL Yostel WOULD BE LIABLE FOR THE PROVISION OF ANY
          SUCH SERVICES AND YOU SHALL HAVE RIGHTS DIRECTLY AGAINST SUCH VENDOR
          FOR ANY DEFICIENCY OR LOSS ARISING FROM THE RESPECTIVE SERVICES AND
          Yostel SHALL IN NO EVENT BE LIABLE FOR ANY CONSEQUENCES ARISING
          THEREFROM. Yostel IS MERELY ACTING AS A FACILITATOR OF SUCH
          THIRD-PARTY SERVICES FOR YOU AND THUS NOT LIABLE FOR ANY CONSEQUENCES
          ARISING THEREFROM.
        </span>
      </p>
    </div>
  );
};

export default Warranties;
